import React, { useState, useEffect } from "react";
import { Card, CardText, CardTitle, Col, Row } from "reactstrap";
import NoDataFound from "../../NoDataFound/NoDataFound";
import { useNavigate } from "react-router-dom";
import "./style.scss";
import card_image from "../../../assets/card_image.png";

const GridView = ({ currentTableData = [] }) => {
  const navigate = useNavigate();

  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    const updatedData = currentTableData.map((place) => ({
      ...place,
      categoryName: place.categoryName || "Default Name",
      categoryTitle: place.categoryTitle || "צדיקים",
      categoryIcon: place.categoryIcon || { card_image },
    }));

    setTableData(updatedData);
  }, [currentTableData]);

  const handleCardClick = (place) => {
    console.log("Clicked place:", place);
    navigate(`/category-detail/?tzadikimId=${place.id}`, {
      state: {
        categoryName: place.categoryName,
        categoryTitle: place.categoryTitle,
        categoryIcon: place.categoryIcon,
        extraVariable: place.extraVariable,
      },
    });
  };

  return (
    <Row>
      {tableData.length === 0 ? (
        <NoDataFound />
      ) : (
        tableData.map((place, index) => (
          <Col xxl="4" lg="6" md="12" key={index} className="mb-4">
            <Card body onClick={() => handleCardClick(place)} className="card">
              <div className="card_header">
                <CardTitle tag="h5" className="card_title">
                  {place?.title}
                </CardTitle>
                <CardText className="card_text">
                  {`${place.nfDay} ${place.nfMonth}, ${place.nfYear}`}
                </CardText>
              </div>
            </Card>
          </Col>
        ))
      )}
    </Row>
  );
};

export default GridView;
